<template>
    <div>
        <div class="modal" tabindex="-1" role="dialog" id="muven-amount-of-sales-filter-modal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Filtro de quantidade de vendas</h5>
                    </div>

                    <div class="modal-body">
                        <div>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-0">
                                        <label>Data inicial</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="amountOfSalesFilter.date.start" />
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-0">
                                        <label>Data final</label>
                                        <v-date-picker 
                                            :input-props="{'class': 'form-control'}" 
                                            popover-visibility="focus"
                                            v-model="amountOfSalesFilter.date.end" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" 
                            class="btn btn-primary"
                            :disabled="loadingFilter"
                            @click="getInfoByFilter(amountOfSalesFilter)">
                            Filtrar

                            <fa icon="sync-alt" spin v-show="loadingFilter"/>
                        </button>
                        
                        <button type="button" 
                            class="btn btn-outline-secondary" 
                            @click="clearFilter(amountOfSalesFilter)">Restaurar</button>

                        <button type="button" 
                            class="btn btn-outline-secondary" 
                            @click="closeFilterModal(ID_MODAL_FILTER)">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="muven-card">
            <div class="muven-card-title">
                <p>
                    Quantidade de vendas

                    <button type="button" 
                        class="btn btn-outline-secondary btn-sm float-right"
                        @click="showFilterModal(ID_MODAL_FILTER)">
                        <fa icon="calendar-alt" />
                    </button>
                </p>

                <p class="muven-card-subtitle">
                    <span>{{amountOfSalesFilter.dateSubmitted.start | dateFilter}}</span> até <span>{{amountOfSalesFilter.dateSubmitted.end | dateFilter}}</span>
                    <span v-show="amountOfSalesFilter.hasChannelList()">
                        <br>
                        <span>Canais: {{amountOfSalesFilter.getChannelListDescription()}}</span>
                    </span>
                    <span v-show="amountOfSalesFilter.hasStoreList()">
                        <br>
                        <span>Lojas: {{amountOfSalesFilter.getStoreListDescription()}}</span>
                    </span>
                </p>
            </div>

            <div>
                <highcharts :options="amountOfSalesChartOptions" ref="chart"/>
            </div>
        </div>
    </div>    
</template>

<script>
import dashboardService from '@/dashboard/services/DashboardService'
import {DashboardAmountOfSalesFilterModel} from '@/dashboard/models/DashboardAmountOfSalesFilterModel'
import { dateFilter } from '@/utils/filters/DateTimeFilter'
import dashboardFilterMixin from '@/dashboard/mixins/DashboardFilterMixin'
import { createGraphic } from '@/utils/normalizers/GraphicNormalizer'
import {format} from 'date-fns'
import {meanBy, round} from 'lodash'
import {averageColor} from '@/dashboard/constants/Color'
import { adjustsDate } from "@/utils/normalizers/DateNormalizer"

const ID_MODAL_FILTER = '#muven-amount-of-sales-filter-modal'

export default {
    name: 'AmountOfSalesCmp',
    mixins: [
        dashboardFilterMixin,
    ],
    data() {
        return {
            ID_MODAL_FILTER,
            loadingFilter: false,
            amountOfSalesFilter: new DashboardAmountOfSalesFilterModel(),
            amountOfSalesList: [],
            amountOfSalesChartOptions: createGraphic({
                chart: {
                    type: 'column',
                    height: 300,
                },
                xAxis: {
                    categories: []
                },
                tooltip: {
                    shared: true
                },
                series: [
                    {
                        type: 'column',
                        name: 'Quantidade de vendas',
                        data: [],
                    },
                    {
                        type: 'line',
                        name: 'Média do período',
                        data: [],
                        color: averageColor
                    },
                ]
            }),   
        }
    }, 
    filters: {
        dateFilter,
    },
    methods: {
        async getInfoByFilter(filter) {
            this.loadingFilter = true

            filter.fillDateWhenEmpty()
            filter.updatesFilterSubmitted()

            await this.drawGraphic(filter)

            this.loadingFilter = false
            this.closeFilterModal(this.ID_MODAL_FILTER)
        },
        async drawGraphic(filter) {
            this.amountOfSalesFilter.updatesFilterSubmittedWith(filter)
            this.amountOfSalesList = await dashboardService.getAmountOfSales(filter)

            this.$refs.chart.chart.xAxis[0].setCategories(this.amountOfSalesList.map((a) => {
                return format(adjustsDate(a.date), 'dd/MM')
            }))

            this.$refs.chart.chart.series[0].setData(this.amountOfSalesList.map((a) => {
                return {
                    y: a.value,
                }
            }))

            this.$refs.chart.chart.series[1].setData(this.amountOfSalesList.map((a) => {
                let value = meanBy(this.$refs.chart.chart.series[0].data, 'y')

                // Checks if there's some decimal info in the result.
                // If there is, then adds one to the value so the decimal
                // info can be removed without worries.
                if ((value - Math.floor(value)) > 0) {
                    value += 1
                }

                return {
                    y: round(value, 0),
                }
            }))
        }
    },
    async mounted() {
        await this.drawGraphic(this.amountOfSalesFilter)
    },
}
</script>
